module.exports = __webpack_public_path__ + "static/media/sign.cf8b686b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sign.jpg
// module id = 5877
// module chunks = 0